import React from "react";

import { CloseCircleOutlined, ExclamationCircleOutlined } from "@ant-design/icons";

import { getIssueDisplayLabel, normalizeIssueType } from "./submissionIssueUtils";

import { ReactComponent as IssueCount } from "../../../../assets/images/sample-submission/IssueCount.svg";

import "./SampleIssuePill.css";

export default function SampleIssuePill({
  issueType,
  label,
  // showCreditsRefunded = false,
  count,
}) {
  if (count != null && count >= 1) {
    return (
      <span className="SampleIssuePill SampleIssuePill--count">
        <IssueCount aria-hidden />
        <span>{`${count} ${count === 1 ? "issue" : "issues"}`}</span>
      </span>
    );
  }

  const normalizedType = normalizeIssueType(issueType);
  const displayLabel = label || getIssueDisplayLabel(normalizedType);

  return (
    <div className="SampleIssuePillGroup">
      <span className={`SampleIssuePill SampleIssuePill--${normalizedType || "default"}`}>
        {normalizedType === "missing" ? (
          <CloseCircleOutlined aria-hidden />
        ) : (
          <ExclamationCircleOutlined aria-hidden />
        )}
        <span>{displayLabel}</span>
      </span>
      {/* {showCreditsRefunded && (
        <span className="SampleIssuePill__Credits">$ Credits Refunded</span>
      )} */}
    </div>
  );
}
